import { render, staticRenderFns } from "./ringratiousetotal.vue?vue&type=template&id=6727271c&"
import script from "./ringratiousetotal.vue?vue&type=script&lang=ts&"
export * from "./ringratiousetotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ringratiousetotal.vue"
export default component.exports